import crudActions from '../../crud/actions'

const actions = crudActions('SETTINGS_LISTS_CAREVISITTYPES_')

export default actions
